module.exports = __webpack_public_path__ + "img/shz.2c520d95.png";